// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getIssueStatusById } from 'app/constants/enums/IssueStatus/main';

/* eslint-disable max-len */
export const OPEN = getIssueStatusById('Open');
export const REJECTED = getIssueStatusById('Rejected');
export const RESOLVED = getIssueStatusById('Resolved');
/* eslint-enable max-len */
